export default __webpack_public_path__ + "images/0d64159d670ec3011e0c59c27ed41f7a-menu-dog-friend.svg";